export default "__VITE_ASSET__8f1597cc__"